import React, { useContext, useEffect, useState } from "react";
import Select from "react-select";
import { CircleSpinnerOverlay } from "react-spinner-overlay";
import { DocumentList } from "../../models/Document";
import { ISelect } from "../../models/General";
import { RootStoreContext } from "../../stores/RootStore";
import MonitoringPage from "../../utils/MonitoringPage";

import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Spinner from 'react-bootstrap/Spinner';

import JSZip from "jszip";
import { saveAs } from "file-saver";

const DocumentsPage = () => {
  const rootStore = useContext(RootStoreContext);
  const emplidVal = window.localStorage.getItem("emplid");
  // const emplidVal = "E024603";
  // const emplidVal = "E023939";

  // const emplidVal = "E024603";
  // const emplidVal = "E081439";

  const lType = [
    {
      value: "SK",
      label: "Decree",
    },
    {
      value: "ST",
      label: "Assignment",
    },
  ];

  const columns = [
    { title: "Document Number", field: "DOC_NO" },
    // { title: "Letter Type", field: "DOC_TYPE", defaultSort: "asc" },
    {
      title: "Action",
      render: (rowData: any) => {
        return (
          <button
            onClick={() => downloadFile(rowData)}
            className="btn btn-info"
            type="button"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-download"
              viewBox="0 0 16 16"
            >
              <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
              <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
            </svg>
          </button>
        );
      },
    },
  ];

  const adminColumns = [
    { title: "ID", field: "EMPLID_LEC" },
    { title: "Name", field: "NAME" },
    { title: "Document Number", field: "DOC_NO" },
    // { title: "Letter Type", field: "DOC_TYPE", defaultSort: "asc" },
    {
      title: "Action",
      render: (rowData: any) => {
        return (
          <React.Fragment>
            <div className="row">
              <div className="col-auto">
                <button
                  style={{ paddingBottom: "20%" }}
                  onClick={() => downloadFile(rowData)}
                  className="btn btn-info"
                  type="button"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-download"
                    viewBox="0 0 16 16"
                  >
                    <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                    <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
                  </svg>
                </button>
              </div>
              {/* {rmFile ? (
                <div className="col-auto">
                  <button
                    onClick={() => showAlertDelete(rowData)}
                    className="btn btn-info"
                    type="button"
                    style={{ paddingBottom: "20%" }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-trash3"
                      viewBox="0 0 16 16"
                    >
                      <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z" />
                    </svg>
                  </button>
                </div>
              ) : (
                ""
              )} */}
            </div>
          </React.Fragment>
        );
      },
    },
  ];

  const [alert, setAlert] = useState(false);
  const [selectedDoc, setSelectedDoc] = useState("");
  const [selectedDocRm, setSelectedDocRm] = useState("");
  const [isAdmin, setIsAdmin] = useState(false);
  const [rmFile, setRmFile] = useState(false);
  const [acadProg, setAcadProg] = useState<ISelect[]>([]);
  const [acadProgVal, setAcadProgVal] = useState("");
  const [lecturer, setLecturer] = useState<ISelect[]>([]);
  const [lecturerVal, setLecturerVal] = useState("ALL");
  const [term, setTerm] = useState<ISelect[]>([]);
  const [termVal, setTermVal] = useState<string>("");
  const [typeVal, settypeVal] = useState<string>("ALL");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [docList, setDocList] = useState<DocumentList[]>([]);

  const [status, setStatus] = useState("success");
  const [message, setMessage] = useState("");
  const [statusAlert, setStatusAlert] = useState(0);
  const [alertBtn, setAlertBtn] = useState(false);

  const { getInstitutionAuto, getCareerAuto, getProgramByInstitution } =
    rootStore.commonStore;

  const {
    getDocumentList,
    getUserRole,
    getLecturer,
    getTerm,
    deleteDocument,
    getLecturerData,
  } = rootStore.document;

  useEffect(() => {
    setIsLoading(true);

    getUserRole(String(emplidVal)).then(
      async (roleVal) => {
        if (roleVal.result[0] == 1) {
          setIsAdmin(true);

          const tempArr = new Array();

          roleVal.result[1].forEach((val: any) => {
            const temp = {
              value: val.ACAD_PROG_VAL,
              label: val.ACAD_PROG_DESC,
            };

            tempArr.push(temp);
          });

          setAcadProg(tempArr);

          getInstitutionAuto(String(emplidVal)).then(
            (inst) => {
              getCareerAuto(
                String(emplidVal),
                String(typeof inst == "string" ? inst : "UMNKG")
              ).then(
                (career) => {
                  getTerm(
                    String(typeof inst == "string" ? inst : "UMNKG"),
                    String(typeof career == "string" ? career : "UGRD")
                  ).then(
                    (terms) => {
                      const newTerms = new Array();

                      terms.result.forEach((val: any) => {
                        const temp = {
                          value: val.CODE,
                          label: val.DESCR,
                        };

                        newTerms.push(temp);
                      });

                      setTerm(newTerms);

                      getLecturer(String(emplidVal)).then(
                        (lec) => {
                          const tempArr = new Array();
                          lec.result.forEach((val: any) => {
                            const temp = {
                              value: val.EMPLID,
                              label: val.NAME,
                            };

                            tempArr.push(temp);
                          });

                          setLecturer(tempArr);
                          setIsLoading(false);
                        },
                        () => {
                          setStatusAlert(1);
                          setMessage("Unable to fetch data");
                          setStatus("error");
                          setIsLoading(false);
                        }
                      );
                    },
                    () => {
                      setStatusAlert(1);
                      setMessage("Unable to fetch data");
                      setStatus("error");
                      setIsLoading(false);
                    }
                  );
                },
                () => {
                  setStatusAlert(1);
                  setMessage("Unable to fetch data");
                  setStatus("error");
                  setIsLoading(false);
                }
              );
            },
            () => {
              setStatusAlert(1);
              setMessage("Unable to fetch data");
              setStatus("error");
              setIsLoading(false);
            }
          );
        } else {
          getLecturerData(String(emplidVal)).then(
            (lecData) => {
              // console.log(lecData.result[0].ACAD_PROG);
              setAcadProgVal(lecData.result[0].ACAD_PROG);
              setLecturerVal(String(emplidVal));

              getTerm(
                lecData.result[0].INSTITUTION,
                lecData.result[0].ACAD_CAREER
              ).then(
                (terms) => {
                  const newTerms = new Array();

                  terms.result.forEach((val: any) => {
                    const temp = {
                      value: val.CODE,
                      label: val.DESCR,
                    };

                    newTerms.push(temp);
                  });

                  setTerm(newTerms);
                  setIsLoading(false);
                },
                () => {
                  setStatusAlert(1);
                  setMessage("Unable to fetch data");
                  setStatus("error");
                  setIsLoading(false);
                }
              );
            },
            () => {
              setStatusAlert(1);
              setMessage("Unable to fetch data");
              setStatus("error");
              setIsLoading(false);
            }
          );
        }

        if (roleVal.result[2] == 1) {
          setRmFile(true);
        }
      },
      () => {
        setStatusAlert(1);
        setMessage("Unable to fetch data");
        setStatus("error");
        setIsLoading(false);
      }
    );
  }, []);

  useEffect(() => {
    if (termVal != "" && acadProgVal != "") {
      getDocs();
    }
  }, [termVal, typeVal, acadProgVal, lecturerVal]);

  const showAlertDelete = (rowData: any) => {
    setSelectedDoc(rowData.DOC_NO);
    setSelectedDocRm(rowData.DOC_NO_FORMATTED);
    setAlert(true);
  };

  const closeAlert = () => {
    setAlert(false);
  };

  const deleteDoc = (docNo: string) => {
    setAlertBtn(true);
    deleteDocument(docNo, String(emplidVal)).then((resp) => {
      setAlert(false);
      setAlertBtn(false);

      if (resp.result >= 1) {
        const tempDocList = docList.filter(
          (doc) => doc.DOC_NO_FORMATTED !== docNo
        );
        setDocList(tempDocList);
      } else {
        setStatusAlert(1);
        setMessage("Failed to delete document");
        setStatus("error");
      }
    });
  };

  const getDocs = () => {
    setIsLoading(true);

    getDocumentList(termVal, typeVal, lecturerVal, acadProgVal).then(
      (docs) => {
        setIsLoading(false);
        setDocList(docs.result);
      },
      (err) => {
        setStatusAlert(1);
        setMessage("Unable to fetch data");
        setStatus("error");
        setIsLoading(false);
      }
    );
  };

  const termChange = (event: any) => {
    setTermVal(event.value);
  };

  const typeChange = (event: any) => {
    settypeVal(event.value);
  };

  const programChange = (event: any) => {
    setAcadProgVal(event.value);
  };

  const emplidChange = (event: any) => {
    setLecturerVal(event.value);
  };

  const downloadFile = (data: any) => {
    const downloadFile = document.createElement("a");
    const fileName = `${
      data.DOC_TYPE.substring(0, 2) == "SK" ? "Ltr_of_Decree" : "Assignment_Ltr"
    }_${data.DOC_NO_FORMATTED}_${data.EMPLID_LEC}.pdf`;
    downloadFile.href = data.DIVA_DOC;
    downloadFile.download = fileName;
    downloadFile.click();
  };

  const downloadAll = () => {
    const zip = new JSZip();

    docList.forEach((doc) => {
      const fileName = `${
        doc.DOC_TYPE.substring(0, 2) == "SK"
          ? "Ltr_of_Decree"
          : "Assignment_Ltr"
      }_${doc.DOC_NO_FORMATTED}_${doc.EMPLID_LEC}.pdf`;

      zip.file(fileName, doc.DIVA_DOC.split(",")[1], { base64: true });
    });

    zip.generateAsync({ type: "blob" }).then((content) => {
      const tempType =
        typeVal != "ALL"
          ? lType[Number(lType.findIndex((x) => x.value == typeVal))].label +
            "_"
          : "";

      const tempEmplid = !isAdmin
        ? String(emplidVal) + "_"
        : lecturerVal == "ALL"
        ? ""
        : lecturerVal + "_";

      const fileZip = `${termVal}_${tempType}${tempEmplid.replace(
        "E",
        ""
      )}${acadProgVal}.zip`;

      saveAs(content, fileZip);
    });
  };

  return (
    <React.Fragment>
      {isLoading ? (
        <CircleSpinnerOverlay
          zIndex={2000}
          loading={isLoading}
          color="#00FFFF"
        />
      ) : (
        <></>
      )}

      <Dialog
        open={alert}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Confirmation</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete document {selectedDoc}?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={closeAlert}
            style={{ color: "blue" }}
            disabled={alertBtn}
          >
            Cancel
          </Button>
          <Button 
            onClick={() => deleteDoc(selectedDocRm)}
            style={{ color: "red" }}
            disabled={alertBtn}
          >
            <Spinner as="span" animation="border" size="sm" style={{marginRight: '2px', display: alertBtn ? 'inline-block' : 'none'}} /> Delete
          </Button >
        </DialogActions>
      </Dialog>

      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1 className="m-0">My Documents</h1>
            </div>
          </div>
        </div>
      </div>

      <section className="content">
        <div className="container-fluid">
          <div className="card pt-3 pl-4 pb-4 pr-4">
            <div className="row">
              <div className="col-4">
                <div className="form-group">
                  <label>
                    <span className="required-symbol">*</span>Term
                  </label>
                  <Select
                    name="term"
                    placeholder="Choose Term"
                    options={term}
                    onChange={termChange}
                  />
                </div>
              </div>
              <div className="col-4">
                <div className="form-group">
                  <label>Letter Type</label>
                  <Select
                    name="type"
                    placeholder="Choose Letter Type"
                    options={lType}
                    onChange={typeChange}
                  />
                </div>
              </div>
              {docList.length > 0 ? (
                <div className="col-4">
                  <div className="form-group">
                    <label style={{ visibility: "hidden" }}>Action</label>
                    <br />
                    <button
                      className="btn btn-info"
                      type="button"
                      onClick={downloadAll}
                    >
                      Download All
                    </button>
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
            {isAdmin ? (
              <div className="row">
                <div className="col-4">
                  <div className="form-group">
                    <label>
                      <span className="required-symbol">*</span>Program
                    </label>
                    <Select
                      name="program"
                      placeholder="Choose Program"
                      options={acadProg}
                      onChange={programChange}
                    />
                  </div>
                </div>
                <div className="col-4">
                  <div className="form-group">
                    <label>Lecturer</label>
                    {/* <input type="text" style={{border: "1px solid #cccccc", padding: "4px 10px 7px 10px", borderRadius: "4px", width: "100%"}} 
                    onBlur={emplidChange} /> */}
                    <Select
                      name="lecID"
                      placeholder="Choose Lecturer"
                      options={lecturer}
                      onChange={emplidChange}
                    />
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
        <div className="container-fluid">
          <MonitoringPage
            list={docList}
            columns={isAdmin ? adminColumns : columns}
            status={status}
            message={message}
            tableName={"Document List"}
            tableMessage={""}
            isLoading={isLoading}
            statusAlert={statusAlert}
            setStatusAlert={setStatusAlert}
          ></MonitoringPage>
        </div>
      </section>
    </React.Fragment>
  );
};

export default DocumentsPage;
